import React from "react";
import OrderTaskForm from "./OrderTaskForm";

const STAGES = ["Solicitud", "Cotización", "Respuesta"];
// Tarea «Registrar solicitud» (actor VENTAS) — FORMCODE ELCOT1. Es el primer paso: aquí se captura la solicitud.
const CONFIG = {
  stage: 0,
  stages: STAGES,
  title: "Registrar solicitud de cotización",
  intro: "Captura lo que pide el cliente. Al enviar, la solicitud pasa a preparar la cotización.",
  sections: [],
  inputsTitle: "Datos de la solicitud",
  inputs: [
    { name: "cliente_nombre", label: "Cliente", required: true, placeholder: "Nombre del cliente" },
    { name: "empresa", label: "Empresa", placeholder: "Opcional" },
    { name: "cliente_telefono", label: "Teléfono", type: "tel", required: true },
    { name: "cliente_email", label: "Email", type: "email" },
    { name: "items", label: "Productos y cantidades", type: "textarea", required: true, placeholder: "Una línea por producto. Ej: Remera DRY2 Pro talla M x 20" },
    { name: "notas", label: "Notas", type: "textarea", placeholder: "Plazo, logo, lugar de entrega…" },
  ],
  optionHints: { "Enviar solicitud": "Pasa a Preparar cotización." },
};

export default function ElevaxRegistrarSolicitud(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
